import { createGlobalStyle } from "styled-components";
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
	Paginacao: {
	  "&& .Mui-selected": {
		color: "#ffff !important",
		backgroundColor: "#0079BA !important",
	  },
	  "&& .MuiPaginationItem-root": {
		color: "#0079BA",
		borderRadius: '0px',
		backgroundColor: '#fff',
		border: '0.5px solid rgba(0,0,0,0.2)',
		margin: 0,
	  },
	  '& .MuiPaginationItem-root:hover': {
        backgroundColor: '#a4c6d9',
      },
	  "&& .MuiPagination-ul": {
		justifyContent: "center",
		fontFamily: "'Montserrat',sans-serif",
	  },
	},
  }));

export const GlobalStyle = createGlobalStyle`

body {
    background: #e6e6e6 !important;
}

*:focus {
    outline: none;
}

html{
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
}

.swal2-timer-progress-bar{
    background: #8B0000
}

#padder{
    min-height: calc(100vh - 272px);
  }

::-webkit-input-placeholder { /* Edge */
  color: var(--grey3);
}

.adjust{
    width: 83%!important;
    transition: 0.8s;    
}

.inadjust{
    width: 100%!important;
    transition: 0.8s;    
}

table {
    border-collapse: collapse;
}

[disabled]{
    opacity: 0.7;
    /* background: #c01818!important; */
    cursor: not-allowed!important;
}

#message{
    display: none;
}

/*modal*/
.modal-header{
    border-bottom: 2px solid #00ACEC !important;
}

.overflow-y-scroll{
    overflow-y: hidden!important
}  

.backwhite{
    background: #fff!important
}

.small, small {
    font-size: 9px;
    font-weight: 400;
    display: block
}

.uk-background-muted{
    background-color: #fff
}

.swal2-title{
    font-size: 1.350em;
}

.header{
    box-sizing: border-box;
    border-bottom: 1px #e5e5e5 solid;
}

.pagination .page-item.active .page-link{
    background-color: #f95100;
}

.pagination .page-item.active .page-link:hover{
    background-color: #f95100;
}

/*  UI KIT   */

.uk-card-default .uk-card-header {
    background-color: #f8f8f8;
    border-bottom: 1px solid #00ACEC;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.uk-button-primary {
    background-color: #00ACEC;
    color: #fff;
    transition: 0.2s;
    &:hover{
        background-color: rgb(31, 127, 191);
        transition: 0.2s
    }
   
}

.uk-navbar {
    display: flex;
    position: relative;
    box-sizing: border-box;
    border-bottom: 3px solid #242424;
}



.uk-link, a {
    color: #0b4381;
    text-decoration: none;
    cursor: pointer;
    transition: 0.2s;
    &:hover{
        color: #00ACEC;
        transition: 0.2s;
        text-decoration: none;
    }
}



ul.uk-nav-sub a:hover {
    background-color: rgb(31, 127, 191, 0.1);
}

.uk-nav-default>li>a:hover{
    color: #00ACEC;
    background-color: rgba(51, 153, 221, 0.1);
}

ul.uk-nav-sub .uk-active {
    background-color: rgb(31, 127, 191, 0.1);
    border-left: 4px solid #00ACEC;
}

.uk-nav-default {
    line-height: 1.4;
    margin: 12px 12px 12px 12px;
    font-size: .875rem;
}

ul.uk-nav-default>li>a {
    color: #222;
    column-gap: 8px;
    text-transform: none;
    font-weight: 400;
}

.uk-nav li>a {
    display: flex;
    align-items: center;
    column-gap: .25em;
    text-decoration: none;
}

.uk-accordion-content {
    background: #fff;
}

/* O uikit-react embute uma segunda cópia do UIkit além da do index.html; cada uma desenha o ícone de fechar */
.uk-alert-close > svg ~ svg {
    display: none;
}


.uk-overflow-medium {
    max-height: 390px;
    overflow-y: auto;
    overflow-x: hidden;
}

.uk-label-danger {
    background-color: #f0506e!important;
    color: #fff;

    a, i{
        color: #fff!important;
    }
}

.uk-label-warning {
    background-color: #faa05a!important;
    color: #fff;

    a, i{
        color: #fff!important;
    }
}


.uk-list>:nth-child(n+2){
        margin-top: 2px;
    }

.uk-button-green {
    background-color: #00ACEC;
    color: #fff;
    border: 1px solid transparent;
    transition: 0.5s;

    &:hover{
        background-color: #00ACEC;
        transition: 0.5s
    }
}

.uk-button-small {
    padding: 0 15px;
    line-height: 28px;
    font-size: 0.875rem;
}

.uk-border-pill {
    border-radius: 500px;
}

.uk-container-xlarge {
    max-width: 1600px;
}

.uk-container{
    padding: 0!important;
}

.uk-font-green-sharp {
    color: #00ACEC !important;
}

.uk-nav-default .uk-nav-divider {
    padding: 0;
}

.uk-border-none{
    border: none
}

.uk-background-green-sharp {
    background-color: #00ACEC;
}

.uk-background-yellow-crusta {
    background-color: #f3c200;
}

.uk-navbar-container:not(.uk-navbar-transparent){
    padding-left: 20px;
}

.content-padder {
    margin-left: 240px;
    padding: 0;
    transition: 0.5s;
}

.content-padder-active{
    margin-left: 0px!important;
    transition: 0.5s;
}

.content-padder-inative{
    margin-left: 240px;
    transition: 0.5s;
}

.uk-background-default {
    background-color: #f8f8f8;
}

.uk-container-xlarge {
    /* max-width: 1920px; */
    padding: 1rem;
}

.uk-background-primary2{
    background-color: var(--blue3);
    color: var(--blue2)
}

.uk-background-grey{
    background-color: var(--grey4);
    color: var(--grey1)
}

.uk-color-blue{
    color: var(--blue2)!important
}

/*  Menu lateral   */
.uk-left-menu-active{
    left: -240px!important;
    transition: 0.5s;
}

.uk-left-menu-inative{
    left: 0;
    transition: 0.5s;
}

.uk-background-grey{
    background-color: #E5E5E5;
    font-weight: 600!important;
}
.uk-accordion-title {
    font-size: 1rem;
}


/*GLOBAL PADRÃO*/

input[type="number"] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

main {
  margin-left: 0;
}

input[type="button"],
input[type="submit"] {
	background: #083f88;
	color: #fff;
	border: none;
	font-size: 14px;
	/* text-transform: uppercase; */
	font-weight: 400;
	cursor: pointer;
	padding: 15px 20px;
	float: left;
	font-family: 'Josefin Sans', sans-serif;
	border-radius: 0.25rem;
}

@media (max-width: 768px) {
  aside {
    opacity: 0;
  }
 
}

@media (min-width: 769px) {
  /* main {
    margin-left: 260px;
  } */
}

.profile-picture {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tab {
  display: none;
}

select,
option {
  font: -moz-pull-down-menu;
}


@media only screen and (max-width: 915px) {

    .uk-left-menu-active{
        left: 0px!important;
    }

    .uk-left-menu-inative{
        left: -240px;
        transition: 0.5s;
    }

    .content-padder-active{
        margin-left: 0px!important;
        transition: 0.5s;
    }

    .content-padder-inative{
        margin-left: 0px;
        transition: 0.5s;
    }

    /*ajustar tabs*/
    .uk-subnav-divider>* {
        padding: 5px 1px;
    }

    .uk-table-hover tbody tr:hover, .uk-table-hover>tr:hover {
        background-color: rgba(51, 153, 221, 0.1);
    }
  

    /* Tabela */
 

    /* .uk-table-striped tbody tr:nth-of-type(odd), .uk-table-striped>tr:nth-of-type(odd){
            padding: 10px 0;
            background: #f0f0f0;
        }
    */
    .uk-table-divider>:first-child>tr:not(:first-child), .uk-table-divider>:not(:first-child)>tr, .uk-table-divider>tr:not(:first-child){
        padding: 12px 0;
    }   

    #table{
        /* float: left; */
        width: 100%;
        position: relative;

        strong{
            float: left;
             /* width: 100%;
            text-align: left */
        }

        tr{
            box-shadow: 0 5px 15px rgb(0 0 0 / 8%);
            padding: 5px;
            margin: 10px 0;
            background: #fff;
        }

        .right{
            margin-right: -55%;
        }

        .rightbutton{
            margin-right:0%;
        }

        tr td:nth-child(1){
            background: #d3d3d3;
            color: #333;
            font-weight: bold
        }

        .limpa{
            background: #E5E5E5!important;
            color: #333!important;
            box-shadow: none;
            border-bottom: none
        }

        .uk-form-width-medium {
            width: 100%;
        }
        
        .uk-table-responsive .uk-table-link:not(:last-child)>a, 
        .uk-table-responsive td:not(:last-child):not(.uk-table-link), 
        .uk-table-responsive th:not(:last-child):not(.uk-table-link) {
            padding: 10px!important;
            border-bottom: 1px #ddd solid;
            text-align: left!important;
        }

        .uk-table-responsive td:not(:first-child):not(.uk-table-link), .uk-table-responsive th:not(:first-child):not(.uk-table-link){  
            text-align: right!important;
        }
      
    }

    

}



`;
